// 部署管理（增删查改）
export const GET_ARRANGEMENT_LIST = 'GET_ARRANGEMENT_LIST'
export const GET_ARRANGEMENT_LIST_ALL = 'GET_ARRANGEMENT_LIST_ALL'
export const SET_ARRANGEMENT_LIST = 'SET_ARRANGEMENT_LIST'
export const ADD_ARRANGEMENT = 'ADD_ARRANGEMENT'
export const EDIT_ARRANGEMENT = 'EDIT_ARRANGEMENT'
export const DELETE_ARRANGEMENT = 'DELETE_ARRANGEMENT'

// 部署关联管理（增删查改）
export const SET_RELATION_LIST = 'SET_RELATION_LIST'
export const GET_ARRANGEMENT_RELATION = 'GET_ARRANGEMENT_RELATION'
export const ADD_ARRANGEMENT_RELATION = 'ADD_ARRANGEMENT_RELATION'
export const EDIT_ARRANGEMENT_RELATION = 'EDIT_ARRANGEMENT_RELATION'
export const DELETE_ARRANGEMENT_RELATION = 'DELETE_ARRANGEMENT_RELATION'

// 发布管理
export const GET_PUBLISH_STATUS = 'GET_PUBLISH_STATUS'
export const PUBLISH_ARRANGEMENT = 'PUBLISH_ARRANGEMENT'

export const GET_ARRANGEMENT_HISTORY_LIST_TOTLAL = 'GET_ARRANGEMENT_HISTORY_LIST_TOTLAL'
export const GET_ARRANGEMENT_HISTORY_LIST_SINGLE = 'GET_ARRANGEMENT_HISTORY_LIST_SINGLE'

export const GET_VERSION_LIST = 'GET_VERSION_LIST'
export const GET_TENANT_LIST = 'GET_TENANT_LIST'
export const GET_ARRANGEMENT_HISTORY_DETAIL = 'GET_ARRANGEMENT_HISTORY_DETAIL'
